export class OfferComission {

  commission_description: string;

  constructor() {
    this.commission_description = '';
  }
}
